module.exports = __webpack_public_path__ + "5e8518f9c48a90941d024e7c190a661e.svg";